export default __webpack_public_path__ + "static/logo-svg-a322cd9ede7c953e4383f49c7b903715.svg";